import axios from "axios"


export const initPasswordReset = async (user: string) => {
    return axios.get(`api/User/InitPasswordReset?user=${user}`)
}
